import React from 'react';
import BaseContactForm from 'commonComponents/forms/BaseContactForm/BaseContactForm';
import styles from './ContactForm.module.scss';

const ContactForm = ({
  specificFields,
  sideBar,
  ...props
}) => {
  return (
    <div className={ styles.ContactForm }>
      <BaseContactForm { ...props }>
        { specificFields }
      </BaseContactForm>
      { sideBar }
    </div>
  );
};

export default ContactForm;
